document.addEventListener('DOMContentLoaded', () => {
	const footers = document.querySelectorAll('.wp-block-affiliates-footer');

	if (!footers.length) {
		return;
	}

	const desktopQuery = window.matchMedia('(min-width: 782px)');

	const syncDetailsState = () => {
		footers.forEach((footer) => {
			const details = footer.querySelectorAll('.footer-block__menu-column');

			details.forEach((item) => {
				if (desktopQuery.matches) {
					item.setAttribute('open', 'open');
				} else {
					item.removeAttribute('open');
				}
			});
		});
	};

	syncDetailsState();

	if (typeof desktopQuery.addEventListener === 'function') {
		desktopQuery.addEventListener('change', syncDetailsState);
	} else if (typeof desktopQuery.addListener === 'function') {
		desktopQuery.addListener(syncDetailsState);
	}
});